import React, { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Drawer,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import DashboardTopbar from "./DashboardTopbar";
import DashboardSidebar, { DASHBOARD_DRAWER_WIDTH } from "./DashboardSidebar";

export default function DashboardLayout() {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const [mobileOpen, setMobileOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const go = (to) => {
    navigate(to);
    if (!isMdUp) setMobileOpen(false);
  };

  const TOPBAR_H = 70;

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#040912",
        background:
          "radial-gradient(1200px 600px at top center, rgba(0,180,255,0.10), transparent 60%), #040912",
      }}
    >
      {/* TOPBAR */}
      <DashboardTopbar
        isMdUp={isMdUp}
        onOpenMobile={() => setMobileOpen(true)}
      />

      <Box sx={{ display: "flex" }}>
        {/* SIDEBAR */}
        <Box
          component="nav"
          sx={{
            width: { md: DASHBOARD_DRAWER_WIDTH },
            flexShrink: { md: 0 },
          }}
        >
          {/* Mobile drawer */}
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={() => setMobileOpen(false)}
            ModalProps={{ keepMounted: true }}
            sx={{
              display: { xs: "block", md: "none" },
              "& .MuiDrawer-paper": {
                width: DASHBOARD_DRAWER_WIDTH,
                border: 0,
                top: `${TOPBAR_H}px`,
                height: `calc(100% - ${TOPBAR_H}px)`,
              },
            }}
          >
            <DashboardSidebar
              pathname={location.pathname}
              onGo={go}
              onGoCheckin={() => go("/checkin")}
            />
          </Drawer>

          {/* Desktop drawer */}
          <Drawer
            variant="permanent"
            open
            sx={{
              display: { xs: "none", md: "block" },
              "& .MuiDrawer-paper": {
                width: DASHBOARD_DRAWER_WIDTH,
                border: 0,
                top: `${TOPBAR_H}px`,
                height: `calc(100% - ${TOPBAR_H}px)`,
              },
            }}
          >
            <DashboardSidebar
              pathname={location.pathname}
              onGo={go}
              onGoCheckin={() => go("/checkin")}
            />
          </Drawer>
        </Box>

        {/* CONTENT */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: { md: `calc(100% - ${DASHBOARD_DRAWER_WIDTH}px)` },
          }}
        >
          {/* spacer exato da altura do AppBar */}
          <Toolbar sx={{ minHeight: TOPBAR_H }} />

          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
